import React from 'react';
import { AlertTriangle, Info, CheckCircle2, X } from 'lucide-react';

export function AlertModal({ isOpen, type = 'info', title, message, onConfirm, onCancel, confirmText = 'ตกลง', cancelText = 'ยกเลิก' }) {
  if (!isOpen) return null;

  const isConfirm = Boolean(onCancel);

  const getIcon = () => {
    switch (type) {
      case 'danger':
      case 'warning':
        return <AlertTriangle className="w-6 h-6 text-red-600" />;
      case 'success':
        return <CheckCircle2 className="w-6 h-6 text-emerald-600" />;
      default:
        return <Info className="w-6 h-6 text-indigo-600" />;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-in fade-in duration-150">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl border border-slate-100 animate-in zoom-in-95 duration-150">
        <div className="flex items-start gap-4 mb-4">
          <div className="p-2.5 rounded-xl bg-slate-50 border border-slate-100 flex-shrink-0">
            {getIcon()}
          </div>
          <div className="flex-1 min-w-0">
            {title && <h3 className="text-base font-extrabold text-slate-900 mb-1">{title}</h3>}
            <div className="text-sm text-slate-700 font-medium leading-relaxed break-words whitespace-pre-line">{message}</div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2.5 pt-2 border-t border-slate-100">
          {isConfirm && (
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded-xl border border-slate-300 text-slate-800 hover:bg-slate-50 font-bold text-xs transition-colors cursor-pointer"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-xl font-bold text-xs text-white transition-colors cursor-pointer ${
              type === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
